import { CIMSModule, CIMSPage, Permission } from 'shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useRFI() {
  return useProtectedMenuItem({
    module: CIMSModule.RFI,
    pages: [
      {
        page: CIMSPage.RFITracker,
        permission: [
          Permission.ViewRequestForInformation,
          Permission.EditRFIResponse,
        ],
      },
      {
        page: CIMSPage.RFIOrganizations,
        permission: Permission.ViewRFIOrganization,
      },
      {
        page: CIMSPage.RFIResponseDisciplines,
        permission: Permission.ViewRFIResponseDiscipline,
      },
      {
        page: CIMSPage.RFIQuickLinks,
        permission: Permission.ViewRFIQuickLink,
      },
      {
        page: CIMSPage.RFINotifications,
        permission: Permission.ViewRFINotification,
      },
    ],
  })
}
